import "./Heading.css";

const Heading = () => {
  return (
    <div className="Heading">
      <div className="Heading-Title">Features</div>
      <p className="Heading-Content">
        Most calendars are designed for teams. Slate is designed for freelancers
        who want a simple way to plan their schedule.
      </p>
    </div>
  );
};

export default Heading;
